// extracted by mini-css-extract-plugin
export default {"divLoading":"Loading_divLoading__siNbj"};